<div class="dialog">
  @if (refreshFromOnline()) {
    <h2 class="import-dialog-title">{{ refreshFromOnlineTitle() }}</h2>
    <p class="extra-info import-refresh-notice">
      Selected sections will overwrite the corresponding parts of this filter.
    </p>
  }

  @if (isFileImport()) {
    <h2 class="import-dialog-title">{{ title() }}</h2>
    <app-rule-preview [rules]="dropPreviewRules()" [largeBackground]="true"></app-rule-preview>

    <div class="import-toggle-row">
      <div class="title-toggle-btn" (click)="toggleImportToNewFilter()">
        <span class="input-group-btn">
          <button type="button" class="btn toggle-btn" [class.off]="!importToNewFilter()"></button>
        </span>
        Import to a New Filter
      </div>
      @if (importToNewFilter()) {
        <input type="text" class="form-control import-filter-name-input" [attr.maxlength]="maxFilterNameLength"
          [(ngModel)]="newFilterName" (keydown)="nameChangeKeyDown($event)"
          (ngModelChange)="onNewFilterNameChange()" (click)="$event.stopPropagation()">
      }
    </div>
    @if (nameError) {
      <p class="import-name-error">{{ nameError }}</p>
    }

    <div class="import-toggle-row">
      <div class="title-toggle-btn" (click)="toggleImportCosmetics()">
        <span class="input-group-btn">
          <button type="button" class="btn toggle-btn" [class.off]="!importCosmetics()"></button>
        </span>
        Import Cosmetics
      </div>
      <div class="title-toggle-btn" (click)="toggleImportRules()">
        <span class="input-group-btn">
          <button type="button" class="btn toggle-btn" [class.off]="!importRules()"></button>
        </span>
        Import Rules
      </div>
      <p class="extra-info import-fine-tune-link">
        (<a class="cursor-pointer" (click)="toggleRuleFineTune()">{{ showRuleFineTune() ? 'Hide import section details' : 'Select sections to import' }}</a>)
      </p>
    </div>

    @if (importCosmetics() && cosmeticImportRuleCount() > 0 && !importToNewFilter()) {
      <div class="import-toggle-row">
        <div class="title-toggle-btn" (click)="sectionsToUpdate.appendToCustomCosmeticRules = !sectionsToUpdate.appendToCustomCosmeticRules">
          <span class="input-group-btn">
            <button type="button" class="btn toggle-btn" [class.off]="!sectionsToUpdate.appendToCustomCosmeticRules"></button>
          </span>
          Append to Your Cosmetic Rules
        </div>
      </div>
    }
  }

  <div class="section-types">
    @if (showRuleSections()) {
      <div class="search-advanced-pane blue">

        <div class="filter-group">
          <div class="filter-group-header">
            <div class="filter">
              <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!myEquipmentAndFlasks"
                (click)="toggleAllMyEquipmentAndFlasks()"></button></span>
              <span class="filter-body">
                <span class="filter-title">
                  {{ actionVerb() }} Favourite Equipment & Flasks
                </span>
              </span>
            </div>
          </div>

          <div class="filter-group-body">
            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.myWeapons"
                  (click)="sectionsToUpdate.myWeapons = !sectionsToUpdate.myWeapons; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  Favourite Weapons
                </div>
              </span>
            </div>

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.myArmour"
                  (click)="sectionsToUpdate.myArmour = !sectionsToUpdate.myArmour; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  Favourite Armour
                </div>
              </span>
            </div>

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.myJewellery"
                  (click)="sectionsToUpdate.myJewellery = !sectionsToUpdate.myJewellery; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  Favourite Jewellery
                </div>
              </span>
            </div>

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.myJewel"
                  (click)="sectionsToUpdate.myJewel = !sectionsToUpdate.myJewel; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  Favourite Jewel
                </div>
              </span>
            </div>

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.myFlasks"
                  (click)="sectionsToUpdate.myFlasks = !sectionsToUpdate.myFlasks; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body" [class.bottom-border]="apply() || !clone()" [class.margin]="apply() || !clone()">
                <div class="filter-title">
                  Favourite Flasks
                </div>
              </span>
            </div>

            @if (showAppendOptions()) {
              <div class="filter filter-property full-span">
                <span class="input-group-btn">
                  <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.appendToMyEquipment"
                    (click)="sectionsToUpdate.appendToMyEquipment = !sectionsToUpdate.appendToMyEquipment"></button>
                </span>
                <span class="filter-body">
                  <div class="filter-title">
                    <span class="filter-title-text">Append to Your Favourite Equipment</span>
                    <div class="filter-tip">
                      <p>If <strong>enabled</strong>, this will <strong>keep your</strong> 'Favourite Equipment & Flasks' rules; and append these. If <strong>disabled</strong>, this will <strong>replace your</strong> 'Favourite Equipment & Flasks' rules.</p>
                    </div>
                  </div>
                </span>
              </div>
            }
          </div>
        </div>

        <div class="filter-group">
          <div class="filter-group-header">
            <div class="filter">
              <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!sectionsToUpdate.quickFilters"
                (click)="sectionsToUpdate.quickFilters = !sectionsToUpdate.quickFilters; sectionsToUpdate.customEquipmentTiers = sectionsToUpdate.quickFilters; onRuleSectionToggle()"></button></span>
              <span class="filter-body">
                <span class="filter-title">
                  <span class="filter-title-text">{{ actionVerb() }} Other Quick Filters</span>
                  <div class="filter-tip">
                    <p>
                      All Quick Filter rules except for 'Favourite Equipment & Flasks'.
                    </p>
                  </div>
                </span>
              </span>
            </div>
          </div>

          <div class="filter-group-body">
            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customEquipmentTiers"
                  (click)="sectionsToUpdate.customEquipmentTiers = !sectionsToUpdate.customEquipmentTiers; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Also Apply Changed Item Tiers</span>
                  <div class="filter-tip">
                    <p>
                      If enabled, this will also copy any changed Item Tiers, e.g. 'Excellent Identified Gear', since they are closely related to the Quick Filters.
                      <br /><br />Note that this does the same thing as the 'Changed Item Tiers' option.
                    </p>
                  </div>
                </div>
              </span>
            </div>

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.identifiedItemConfigs"
                  (click)="sectionsToUpdate.identifiedItemConfigs = !sectionsToUpdate.identifiedItemConfigs; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Also Apply Identified Item Configurations</span>
                  <div class="filter-tip">
                    <p>
                      If enabled, this will also copy any changed Identified Items configurations, e.g. 'Excellent Identified Gear'. This will always override the target configurations.
                    </p>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>

      </div>

      <div class="search-advanced-pane blue">
        <div class="filter-group">
          <div class="filter-group-header">
            <div class="filter">
              <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!allCustomTiers"
                (click)="toggleAllCustomTiers()"></button></span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">{{ actionVerb() }} Manually Changed Tiers</span>
                </div>
              </span>
            </div>
          </div>

          <div class="filter-group-body">
            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customCurrencyAndDivCardTiers"
                  (click)="sectionsToUpdate.customCurrencyAndDivCardTiers = !sectionsToUpdate.customCurrencyAndDivCardTiers; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Changed Currency {{ poe1 ? ' & Divination Card' : '' }} Tiers</span>
                </div>
              </span>
            </div>

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customUniqueTiers"
                  (click)="sectionsToUpdate.customUniqueTiers = !sectionsToUpdate.customUniqueTiers; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Changed Unique Tiers</span>
                </div>
              </span>
            </div>

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customChanceBaseTiers"
                  (click)="sectionsToUpdate.customChanceBaseTiers = !sectionsToUpdate.customChanceBaseTiers; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Changed Chance Base Tiers</span>
                </div>
              </span>
            </div>

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customGearTiers"
                  (click)="sectionsToUpdate.customGearTiers = !sectionsToUpdate.customGearTiers; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Changed Gear Tiers</span>
                </div>
              </span>
            </div>

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customJewelleryTiers"
                  (click)="sectionsToUpdate.customJewelleryTiers = !sectionsToUpdate.customJewelleryTiers; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Changed Jewellery Tiers</span>
                </div>
              </span>
            </div>

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customEquipmentTiers"
                  (click)="sectionsToUpdate.customEquipmentTiers = !sectionsToUpdate.customEquipmentTiers; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Changed Item Tiers</span>
                  <div class="filter-tip">
                    <p>
                      Copy any changed Quick Filter Item Tiers,
                      <br />e.g. 'Excellent Identified Gear'.
                      <br /><br />Note that this does the same thing as the
                      <br />'Changed Custom Item Tiers' sub-option
                      <br />of the 'Quick Filters' option.
                    </p>
                  </div>
                </div>
              </span>
            </div>

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customModTiers"
                  (click)="sectionsToUpdate.customModTiers = !sectionsToUpdate.customModTiers; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body bottom-border margin">
                <div class="filter-title">
                  <span class="filter-title-text">Changed Mod Tiers</span>
                </div>
              </span>
            </div>

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.tieringModeCustom"
                  (click)="sectionsToUpdate.tieringModeCustom = !sectionsToUpdate.tieringModeCustom; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Custom Currency Tiering Mode</span>
                </div>
              </span>
            </div>

            @if (poe1) {
              <div class="filter filter-property full-span">
                <span class="input-group-btn">
                  <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.divCardTieringModeCustom"
                    (click)="sectionsToUpdate.divCardTieringModeCustom = !sectionsToUpdate.divCardTieringModeCustom; onRuleSectionToggle()"></button>
                </span>
                <span class="filter-body">
                  <div class="filter-title">
                    <span class="filter-title-text">Custom Divination Card Tiering Mode</span>
                  </div>
                </span>
              </div>
            }

            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.uniquesTieringModeCustom"
                  (click)="sectionsToUpdate.uniquesTieringModeCustom = !sectionsToUpdate.uniquesTieringModeCustom; onRuleSectionToggle()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Custom Unique Tiering Mode</span>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div class="filter-group">
          <div class="filter-group-header">
            <div class="filter">
              <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customRules"
                (click)="sectionsToUpdate.customRules = !sectionsToUpdate.customRules; onRuleSectionToggle()"></button></span>
              <span class="filter-body">
                <span class="filter-title">
                  {{ actionVerb() }} Custom Rules
                </span>
              </span>
            </div>
          </div>

          @if (showAppendOptions()) {
            <div class="filter-group-body">
              <div class="filter filter-property full-span">
                <span class="input-group-btn">
                  <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.appendToCustomRules"
                    (click)="sectionsToUpdate.appendToCustomRules = !sectionsToUpdate.appendToCustomRules"></button>
                </span>
                <span class="filter-body">
                  <div class="filter-title">
                    <span class="filter-title-text">Append to Your Custom Rules</span>
                    <div class="filter-tip">
                      <p>If <strong>enabled</strong>, this will <strong>keep your</strong> Custom Rules;
                        <br />and append these. If <strong>disabled</strong>,
                        <br />this will <strong>replace your</strong> Custom Rules.</p>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          }
        </div>

        <div class="filter-group">
          <div class="filter-group-header">
            <div class="filter">
              <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!sectionsToUpdate.freeRules"
                (click)="sectionsToUpdate.freeRules = !sectionsToUpdate.freeRules; onRuleSectionToggle()"></button></span>
              <span class="filter-body">
                <span class="filter-title">
                  {{ actionVerb() }} Free-text Rules
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      @if (showCloneApplyTierCosmetics()) {
        <div class="search-advanced-pane full-width">
          <div class="filter-group">

            <div class="filter-group-header">
              <div class="filter">
                <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!sectionsToUpdate.tierCosmetics"
                  (click)="sectionsToUpdate.tierCosmetics = !sectionsToUpdate.tierCosmetics; onRuleSectionToggle()"></button></span>
                <span class="filter-body">
                  <span class="filter-title">
                    <span class="filter-title-text">{{ actionVerb() }} Drop Tier Cosmetics, Custom Rule Styles & Overrides</span>
                    <div class="filter-tip">
                      <p>
                        Custom Rule Styles are the Custom Styles set for Quick Filter Rules, such as a custom Quest Items style, or custom styles for any of the Item rules such as 'Excellent Identified Gear'.
                      </p>
                    </div>
                  </span>
                </span>
              </div>
            </div>

            <div class="filter-group-body filter filter-padded-left">
              <app-rule-preview [rules]="tierCosmeticPreviewRules" [largeBackground]="true"></app-rule-preview>
            </div>

          </div>
        </div>
      }

      @if (showCloneApplyCustomCosmeticRules()) {
        <div class="search-advanced-pane full-width">
          <div class="filter-group">

            <div class="filter-group-header">
              <div class="filter">
                <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customCosmeticRules"
                  (click)="sectionsToUpdate.customCosmeticRules = !sectionsToUpdate.customCosmeticRules; onRuleSectionToggle()"></button></span>
                <span class="filter-body">
                  <span class="filter-title">
                    {{ actionVerb() }} Custom Cosmetic Rules
                  </span>
                </span>
              </div>
            </div>

            @if (showAppendOptions()) {
              <div class="filter-group-body">
                <div class="filter filter-property full-span">
                  <span class="input-group-btn">
                    <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.appendToCustomCosmeticRules"
                      (click)="sectionsToUpdate.appendToCustomCosmeticRules = !sectionsToUpdate.appendToCustomCosmeticRules"></button>
                  </span>
                  <span class="filter-body">
                    <div class="filter-title">
                      <span class="filter-title-text">Append to Your Cosmetic Rules</span>
                      <div class="filter-tip">
                        <p>If <strong>enabled</strong>, this will <strong>keep your</strong> Custom Cosmetic Rules; and append these. If <strong>disabled</strong>, this will <strong>replace your</strong> Custom Cosmetic Rules.</p></div>
                      </div>
                  </span>
                </div>
              </div>
            }

            <div class="filter-group-body filter filter-padded-left">
              <app-rule-preview [rules]="cosmeticImportRulesPreviewRules()"></app-rule-preview>
            </div>

          </div>
        </div>
      }
    }
  </div>

  <div class="controls dialog-controls">
    <button type="button" class="btn dialog-btn dialog-main-btn" (click)="importSections()">
      {{ primaryActionLabel() }}
    </button>

    <button type="button" class="btn dialog-btn dialog-cancel-btn" (click)="closeDialog()">
      Cancel
    </button>
  </div>
</div>
